import React, { useEffect, useState, useContext } from 'react';
import { Card, Layout, message } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { AuthContext } from '../../config/AuthContext';
import JutgeColors from '../../styles/JutgeColors';
import AppSiderJavamons from "./components/AppSiderJavamons";

const { Content } = Layout;

import {
    GetJavamonConfig,
    GetTrofeos,
    GetSkins,
    GetUsersEquipment,
    GetSceneActivities,
    GetSceneNames,
    GetRewardsUsageOverview
} from '../../dao/jutge/GetJavamonConfig';
import { GetAllAules } from "../../dao/GetAllAules";
import { GetAules } from "../../dao/GetAules";
import { GetUsuariIdJutgeActivitats } from "../../dao/jutge/GetUsuariIdJutgeActivitats";
import { GetBotines } from "../../dao/jutge/BotinesDao";
import { GetAlumneAulesId } from "../../dao/abp/GetAlumnesAulesId";
import { GetAulaAlumnesModal } from "../../dao/GetAulaAlumnesModal";

import { TabJavamons } from './javmons/TabJavamons';
import { TabTrofeos } from './javmons/TabTrofeos';
import { TabEquipment } from './javmons/TabEquipment';
import { TabAvatars } from './javmons/TabAvatars';
import { TabUserEquipment } from './javmons/TabUserEquipment';
import { TabSceneActivities } from './javmons/TabSceneActivities';
import { TabBotines } from './javmons/TabBotines';
import { TabHistorial } from './javmons/TabHistorial';
import { GetRewardsHistory } from '../../dao/jutge/GetJavamonConfig';
const TAB_URL_MAP: Record<string, { key: string; name: string; url: string }> = {
    'javamons': { key: '1', name: 'Javamons', url: '/jutge/javamon/config/javamons' },
    'trofeos': { key: '4', name: 'Trofeos', url: '/jutge/javamon/config/trofeos' },
    'skins': { key: '5', name: 'Configuración Skins', url: '/jutge/javamon/config/skins' },
    'avatares': { key: '6', name: 'Avatares', url: '/jutge/javamon/config/avatares' },
    'equipment': { key: '7', name: 'Equipamiento de Usuarios', url: '/jutge/javamon/config/equipment' },
    'scenes': { key: '8', name: 'Mapas y Actividades', url: '/jutge/javamon/config/scenes' },
    'botines': { key: '9', name: 'Botines', url: '/jutge/javamon/config/botines' },
    'historial': { key: '10', name: 'Historial de recompensas', url: '/jutge/javamon/config/historial' },
};

const KEY_TO_TAB_MAP: Record<string, { slug: string; name: string; url: string }> = {
    '1': { slug: 'javamons', name: 'Javamons', url: '/jutge/javamon/config/javamons' },
    '4': { slug: 'trofeos', name: 'Trofeos', url: '/jutge/javamon/config/trofeos' },
    '5': { slug: 'skins', name: 'Configuración Skins', url: '/jutge/javamon/config/skins' },
    '6': { slug: 'avatares', name: 'Avatares', url: '/jutge/javamon/config/avatares' },
    '7': { slug: 'equipment', name: 'Equipamiento de Usuarios', url: '/jutge/javamon/config/equipment' },
    '8': { slug: 'scenes', name: 'Mapas y Actividades', url: '/jutge/javamon/config/scenes' },
    '9': { slug: 'botines', name: 'Botines', url: '/jutge/javamon/config/botines' },
    '10': { slug: 'historial', name: 'Historial de recompensas', url: '/jutge/javamon/config/historial' },
};

const ConfiguracioJavamons = () => {
    const { user, userId: contextUserId, setBreadCrumb } = useContext(AuthContext);
    const userId = user?.id || (user as any)?.idUsuari || contextUserId;
    const navigate = useNavigate();
    const { tab } = useParams<{ tab?: string }>();
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [config, setConfig] = useState<any>({ seasons: [], rarities: [], javamons: [], trofeos: [] });
    const [skinsConfig, setSkinsConfig] = useState<any>({ skins: [], armes: [], escuts: [], arcs: [], flechas: [], magias: [], avatars: [] });
    const [usersEquipment, setUsersEquipment] = useState<any[]>([]);
    const [sceneActivities, setSceneActivities] = useState<any[]>([]);
    const [sceneNames, setSceneNames] = useState<any[]>([]);
    const [aulas, setAulas] = useState<any[]>([]);
    const [activitats, setActivitats] = useState<any[]>([]);
    const [botines, setBotines] = useState<any[]>([]);
    const [historial, setHistorial] = useState<any[]>([]);
    const [loadingHistorial, setLoadingHistorial] = useState<boolean>(false);

    // Recompensas / Dónde se consigue cada cosa (Vista de Uso)
    const [rewardsUsage, setRewardsUsage] = useState<any>({ problemas: [], cazas: [], shop: [], botines: [] });
    const [loadingRewardsUsage, setLoadingRewardsUsage] = useState<boolean>(false);

    const isAdmin = user?.tipus === "0";
    const isProfesor = user?.tipus === "1";

    // Aulas del profesor y filtro seleccionado para Equipamiento de Usuarios
    const [teacherAulas, setTeacherAulas] = useState<any[]>([]);
    const [selectedAulaIdEquipment, setSelectedAulaIdEquipment] = useState<string | number>('all');
    const [aulaStudentsMap, setAulaStudentsMap] = useState<Record<string | number, Set<number>>>({});

    const fetchConfig = async () => {
        setLoading(true);
        try {
            const data = await GetJavamonConfig();
            if (!data) throw new Error('No data');
            setConfig((prev: any) => ({
                ...prev,
                seasons: data.seasons ? JSON.parse(data.seasons) : [],
                rarities: data.rarities ? JSON.parse(data.rarities) : [],
                javamons: data.javamons ? JSON.parse(data.javamons).map((x: any) => ({ ...x, _type: 'javamon' })) : []
            }));
        } catch (e) {
            message.error("Error cargando configuración");
        }
        setLoading(false);
    };

    const fetchTrofeos = async () => {
        setLoading(true);
        try {
            const trofeosData = await GetTrofeos();
            setConfig((prev: any) => ({
                ...prev,
                trofeos: trofeosData ? trofeosData.map((x: any) => ({ ...x, _type: 'trofeo' })) : []
            }));
        } catch (e) {
            message.error("Error cargando trofeos");
        }
        setLoading(false);
    };

    const fetchSkinsConfig = async () => {
        setLoading(true);
        try {
            const data = await GetSkins();
            if (data) {
                setSkinsConfig({
                    skins: data.skins ? data.skins.map((x: any) => ({ ...x, _type: 'skin' })) : [],
                    armes: data.armes ? data.armes.map((x: any) => ({ ...x, _type: 'arma' })) : [],
                    escuts: data.escuts ? data.escuts.map((x: any) => ({ ...x, _type: 'escut' })) : [],
                    arcs: data.arcs ? data.arcs.map((x: any) => ({ ...x, _type: 'arc' })) : [],
                    flechas: data.flechas ? data.flechas.map((x: any) => ({ ...x, _type: 'flecha' })) : [],
                    magias: data.magias ? data.magias.map((x: any) => ({ ...x, _type: 'magia' })) : [],
                    avatars: data.avatars ? data.avatars.map((x: any) => ({ ...x, _type: 'avatar' })) : []
                });
            }
        } catch (e) {
            console.error(e);
            message.error("Error cargando skins");
        }
        setLoading(false);
    };

    const fetchSceneActivities = async () => {
        setLoading(true);
        try {
            const data = await GetSceneActivities();
            if (data) {
                setSceneActivities(data);
            }
        } catch (e) {
            message.error("Error cargando mapas y actividades");
        }
        setLoading(false);
    };

    const fetchSceneNames = async () => {
        setLoading(true);
        try {
            const data = await GetSceneNames();
            if (data) {
                setSceneNames(data);
            }
        } catch (e) {
            message.error("Error cargando nombres de escena");
        }
        setLoading(false);
    };

    const fetchAulas = async () => {
        try {
            const data = await GetAllAules("");
            if (data) {
                setAulas(data);
            }
        } catch (e) {
            message.error("Error cargando aulas");
        }
    };

    const fetchActivitats = async () => {
        try {
            const data = await GetUsuariIdJutgeActivitats(userId + "");
            if (data) setActivitats(data);
        } catch (e) {
            console.error("Error fetching activitats");
        }
    };

    const fetchBotines = async () => {
        setLoading(true);
        try {
            const data = await GetBotines();
            setBotines(Array.isArray(data) ? data : []);
        } catch (e) {
            message.error("Error cargando botines");
        }
        setLoading(false);
    };

    // Cargar alumnos de un aula específica bajo demanda
    const loadStudentsForAula = async (aulaId: number | string) => {
        if (aulaId === 'all') return;
        const aulaKey = String(aulaId);
        if (aulaStudentsMap[aulaKey] && aulaStudentsMap[aulaKey].size > 0) return;

        try {
            const idSet = new Set<number>();
            try {
                const modalData = await GetAulaAlumnesModal(aulaId);
                if (Array.isArray(modalData)) {
                    modalData.forEach((st: any) => {
                        if (st.in_aula === undefined || st.in_aula === 1 || st.in_aula === true) {
                            const id = st.id || st.id_usuari;
                            if (id) idSet.add(Number(id));
                        }
                    });
                }
            } catch (e1) {
                console.warn(`GetAulaAlumnesModal failed for aula ${aulaId}`, e1);
            }

            if (idSet.size === 0) {
                try {
                    const students = await GetAlumneAulesId(String(aulaId));
                    if (Array.isArray(students)) {
                        students.forEach((st: any) => {
                            const id = st.id || st.id_usuari;
                            if (id) idSet.add(Number(id));
                        });
                    }
                } catch (e2) {
                    console.warn(`GetAlumneAulesId failed for aula ${aulaId}`, e2);
                }
            }

            setAulaStudentsMap(prev => ({
                ...prev,
                [aulaId]: idSet,
                [aulaKey]: idSet
            }));
        } catch (err) {
            console.error(`Error loading students for aula ${aulaId}`, err);
        }
    };

    const fetchClassroomsForEquipment = async () => {
        if (!userId) return;
        try {
            let aulesList: any[] = [];
            if (isProfesor) {
                const aulesData = await GetAules(String(userId));
                aulesList = Array.isArray(aulesData) ? aulesData : [];
            } else if (isAdmin) {
                const aulesData = await GetAllAules("");
                aulesList = Array.isArray(aulesData) ? aulesData : [];
            }
            setTeacherAulas(aulesList);

            if (aulesList.length > 0) {
                if (isProfesor && aulesList.length === 1) {
                    setSelectedAulaIdEquipment(aulesList[0].id);
                    await loadStudentsForAula(aulesList[0].id);
                } else if (isProfesor) {
                    await Promise.all(aulesList.map((aula: any) => loadStudentsForAula(aula.id)));
                } else if (isAdmin && selectedAulaIdEquipment !== 'all') {
                    await loadStudentsForAula(selectedAulaIdEquipment);
                }
            }
        } catch (e) {
            console.error("Error fetching classrooms for equipment:", e);
        }
    };

    const fetchUsersEquipment = async () => {
        setLoading(true);
        try {
            const data = await GetUsersEquipment();
            if (data) {
                setUsersEquipment(data);
            }
            await fetchClassroomsForEquipment();
        } catch (e) {
            console.error("Error fetching users equipment:", e);
            message.error("Error cargando equipamiento de usuarios");
        }
        setLoading(false);
    };

    const fetchRewardsUsage = async () => {
        setLoadingRewardsUsage(true);
        try {
            const data = await GetRewardsUsageOverview();
            if (data) {
                setRewardsUsage(data);
            }
        } catch (e) {
            console.error("Error fetching rewards usage overview:", e);
        }
        setLoadingRewardsUsage(false);
    };

    const fetchHistorial = async () => {
        setLoadingHistorial(true);
        try {
            const data = await GetRewardsHistory();
            setHistorial(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error("Error fetching rewards history:", e);
        }
        setLoadingHistorial(false);
    };

    // Resolver la clave activa de tab a partir del param de la URL (/javamon/config/:tab)
    const currentTabKey = (tab && TAB_URL_MAP[tab.toLowerCase()]) ? TAB_URL_MAP[tab.toLowerCase()].key : '1';
    const [activeTabKey, setActiveTabKey] = useState<string>(currentTabKey);

    useEffect(() => {
        if (tab && TAB_URL_MAP[tab.toLowerCase()]) {
            const resolved = TAB_URL_MAP[tab.toLowerCase()];
            setActiveTabKey(resolved.key);
            triggerFetchForTab(resolved.key);

            // Breadcrumb correspondiente al subtab
            setBreadCrumb([
                { nom: 'Home', nav: '/home' },
                { nom: 'jutge', nav: '/jutge' },
                { nom: 'Javamons', nav: '/jutge/javamon/config' },
                { nom: resolved.name, nav: resolved.url }
            ], true);
        } else {
            setActiveTabKey('1');
            setBreadCrumb([
                { nom: 'Home', nav: '/home' },
                { nom: 'jutge', nav: '/jutge' },
                { nom: 'Javamons', nav: '/jutge/javamon/config' },
                { nom: 'Javamons', nav: '/jutge/javamon/config/javamons' }
            ], true);
        }
    }, [tab]);

    const triggerFetchForTab = (key: string) => {
        if (key === '1' || key === '2' || key === '3') {
            fetchConfig();
            fetchRewardsUsage();
        } else if (key === '4') {
            fetchTrofeos();
        } else if (key === '5' || key === '6') {
            fetchSkinsConfig();
            fetchRewardsUsage();
        } else if (key === '7') {
            fetchUsersEquipment();
            fetchSkinsConfig();
        } else if (key === '8') {
            fetchSceneActivities();
            fetchSceneNames();
            fetchAulas();
        } else if (key === '9') {
            fetchBotines();
        } else if (key === '10') {
            fetchHistorial();
            if (isProfesor || isAdmin) {
                fetchClassroomsForEquipment();
            }
        }
    };

    const handleTabChange = (key: string) => {
        setActiveTabKey(key);
        triggerFetchForTab(key);
        const mapped = KEY_TO_TAB_MAP[key];
        if (mapped) {
            navigate(mapped.url);
        }
    };

    useEffect(() => {
        if (user && user.tipus !== "0" && user.tipus !== "1") {
            navigate('/jutge');
            return;
        }
        fetchConfig();
        fetchActivitats();
        fetchAulas();
        fetchSkinsConfig();
        fetchRewardsUsage();
        if (isProfesor || isAdmin) {
            fetchClassroomsForEquipment();
        }
        if (tab === 'botines' || currentTabKey === '9') {
            fetchBotines();
        }
    }, [user, navigate, isProfesor, isAdmin, userId]);

    return (
        <>
            <AppSiderJavamons setTabKey={handleTabChange} />
            <Content style={{ padding: '0 24px', minHeight: 'calc(100vh - 64px)' }}>
                <Card
                    bordered={false}
                    style={{
                        boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                        background: '#fff',
                        marginBottom: '20px'
                    }}
                >
                    {activeTabKey === '1' && (
                        <TabJavamons
                            isAdmin={isAdmin}
                            loading={loading}
                            config={config}
                            setConfig={setConfig}
                            skinsConfig={skinsConfig}
                            rewardsUsage={rewardsUsage}
                            loadingRewardsUsage={loadingRewardsUsage}
                            fetchConfig={fetchConfig}
                            fetchRewardsUsage={fetchRewardsUsage}
                        />
                    )}

                    {activeTabKey === '4' && (
                        <TabTrofeos
                            isAdmin={isAdmin}
                            loading={loading}
                            trofeos={config.trofeos}
                            fetchTrofeos={fetchTrofeos}
                        />
                    )}

                    {activeTabKey === '5' && (
                        <TabEquipment
                            isAdmin={isAdmin}
                            loading={loading}
                            skinsConfig={skinsConfig}
                            fetchSkinsConfig={fetchSkinsConfig}
                            rewardsUsage={rewardsUsage}
                            loadingRewardsUsage={loadingRewardsUsage}
                            fetchRewardsUsage={fetchRewardsUsage}
                        />
                    )}

                    {activeTabKey === '6' && (
                        <TabAvatars
                            isAdmin={isAdmin}
                            loading={loading}
                            avatars={skinsConfig.avatars}
                            fetchSkinsConfig={fetchSkinsConfig}
                            rewardsUsage={rewardsUsage}
                            loadingRewardsUsage={loadingRewardsUsage}
                            fetchRewardsUsage={fetchRewardsUsage}
                        />
                    )}

                    {activeTabKey === '7' && (
                        <TabUserEquipment
                            isAdmin={isAdmin}
                            isProfesor={isProfesor}
                            currentUserId={userId}
                            loading={loading}
                            usersEquipment={usersEquipment}
                            skinsConfig={skinsConfig}
                            teacherAulas={teacherAulas}
                            selectedAulaIdEquipment={selectedAulaIdEquipment}
                            setSelectedAulaIdEquipment={setSelectedAulaIdEquipment}
                            aulaStudentsMap={aulaStudentsMap}
                            loadStudentsForAula={loadStudentsForAula}
                            fetchUsersEquipment={fetchUsersEquipment}
                            fetchSkinsConfig={fetchSkinsConfig}
                        />
                    )}

                    {activeTabKey === '8' && (
                        <TabSceneActivities
                            isAdmin={isAdmin}
                            loading={loading}
                            sceneActivities={sceneActivities}
                            sceneNames={sceneNames}
                            aulas={aulas}
                            activitats={activitats}
                            fetchSceneActivities={fetchSceneActivities}
                            fetchSceneNames={fetchSceneNames}
                        />
                    )}

                    {activeTabKey === '9' && (
                        <TabBotines
                            isAdmin={isAdmin}
                            loading={loading}
                            botines={botines}
                            fetchBotines={fetchBotines}
                        />
                    )}

                    {activeTabKey === '10' && (
                        <TabHistorial
                            isAdmin={isAdmin}
                            isProfesor={isProfesor}
                            loading={loadingHistorial}
                            history={historial}
                            teacherAulas={teacherAulas}
                            selectedAulaIdEquipment={selectedAulaIdEquipment}
                            setSelectedAulaIdEquipment={setSelectedAulaIdEquipment}
                            aulaStudentsMap={aulaStudentsMap}
                            loadStudentsForAula={loadStudentsForAula}
                            fetchHistorial={fetchHistorial}
                        />
                    )}
                </Card>
            </Content>
        </>
    );
};

export default ConfiguracioJavamons;
